const routes = {
  home: {
    value: '/'
  },
  signUp: {
    value: '/sign-up'
  },
  login: {
    value: '/login'
  },
  logout: {
    value: '/logout'
  },
  forgotPassword: {
    value: '/forgot-password'
  },
  resetPassword: {
    value: '/reset-password'
  },
  selectOrganization: {
    value: '/select-organization'
  },
  createAccount: {
    value: '/create-account'
  },
  teams: {
    value: '/teams',
    new: {
      value: '/teams/new'
    },
    detail: {
      value: (id: string | number) => `/teams/${id}`
    }
  },
  verifyEmail: {
    value: '/verify-email'
  },
  // Coach / Program Admin onboarding, entered after email verification: pick
  // whether to start a new Organization or join one by invitation, then name it.
  getStarted: {
    value: '/get-started'
  },
  createOrganization: {
    value: '/create-organization'
  },
  youthAthleteProfile: {
    value: '/youth-athlete-profile'
  },
  selectProfile: {
    value: '/select-profile'
  },
  playerProfile: {
    value: '/player-profile',
    userId: {
      value: (userId: string | number) => `/player-profile/${userId}`
    }
  },
  dashboard: {
    value: '/dashboard'
  },
  playDashboard: {
    value: '/play-dashboard'
  },
  playProfile: {
    value: '/play-profile',
    detail: {
      value: (profileId: string | number) => `/play-profile/${profileId}`
    }
  },
  accountSettings: {
    value: '/account-settings'
  },
  editProfile: {
    value: '/edit-profile'
  },
  editProfileMetrics: {
    value: '/edit-profile/metrics'
  },
  processes: {
    value: '/drafts',
    processId: {
      value: (processId: string) => `/drills/${processId}`
    }
  },
  search: {
    value: '/search'
  },
  // The Organization's Content Item library: Drills that can sit in many Stacks.
  contentItems: {
    value: '/content-items',
    contentItemId: {
      value: (contentItemId: number | string) => `/content-items/${contentItemId}`
    }
  },
  collections: {
    value: '/collections',
    collectionId: {
      value: (collectionId: string) => `/collections/${collectionId}`
    },
    collectionOfGroup: {
      value: (groupId: string) => `/collections?groupId=${groupId}`
    }
  },
  // Organization page — the Program Admin's org context (membership, administrators,
  // information, settings, billing). Replaced the standalone Team Members page,
  // which now lives inside it as the Org Membership tab.
  organization: {
    value: '/organization'
  },
  users: {
    value: '/users',
    userId: {
      value: (userId: string) => `/users/${userId}`
    }
  },
  groups: {
    value: '/groups',
    groupId: {
      value: (groupId: string) => `/groups/${groupId}`
    }
  },
  commonLibrary: {
    value: '/common-library'
  },
  setting: {
    value: '/setting',
    iconBuilder: {
      value: '/setting/icon-builder'
    },
    tag: {
      value: '/setting/tag'
    },
    appearance: {
      value: '/setting/appearance'
    },
    sso: {
      value: '/setting/sso'
    },
    metric: {
      value: '/setting/metric'
    },
    billing: {
      value: '/setting/billing'
    }
  },
  notifications: {
    value: '/notifications'
  },
  archive: {
    value: '/archive'
  },
  plans: {
    value: '/plans',
    planId: {
      value: (planId: string) => `/plans/${planId}`
    },
    trainingPlanId: {
      value: (planId: string) => `/plans/training/${planId}`
    },
    previewId: {
      value: (planId: string | number) => `/plans/${planId}/preview`
    },
    stationId: {
      value: (workplanId: string) => `/station/${workplanId}`
    },
    trainingAssignments: {
      value: '/training-assignments',
      assignmentId: {
        value: (id: string | number) => `/training-assignments/${id}`
      }
    }
  },
  schedule: {
    value: '/schedule'
  },
  messages: {
    value: '/messages'
  },
  report: {
    organization: {
      value: '/organization/report'
    }
  },
  playerAssignments: {
    value: '/player/assignments',
    assignmentDetail: {
      value: (assignmentId: string | number) => `/player/assignments/${assignmentId}`
    },
    weekDetail: {
      value: (assignmentId: string | number, weekId: string | number) =>
        `/player/assignments/${assignmentId}/week/${weekId}`
    },
    stationDetail: {
      value: (assignmentId: string | number, stationId: string | number) =>
        `/player/assignments/${assignmentId}/station/${stationId}`
    }
  },
  googleSsoRoleSelect: {
    value: '/google-sso-role-select'
  },
  linkGoogle: {
    value: '/link-google'
  },
  admin: {
    value: '/',
    report: {
      value: '/report'
    },
    releaseNotes: {
      value: '/release-notes'
    }
  }
}

export default routes
